export default __webpack_public_path__ + "static/media/SRI.b93a4c73.svg";